module.exports = __webpack_public_path__ + "static/media/external-link.7bd9d744.svg";